export default __webpack_public_path__ + "static/SEO_MBIP-c9cb295d18b6512d682fe873ee3f4dea.jpg";